export default "__VITE_ASSET__DDCKvYM4__"